import Invitations from 'pages/Invitations/container';

export default Invitations;
